// 前端 feature flag(依 hostname 判環境,同國中版 chaiwriting-j/utils/featureFlags.js 做法)。

// 自動拉角點:只用在手動四角拖曳的「調整邊界」視窗(自動預填拉角起點,見 UploadEssay 的
// initializePerspectivePoints),打的是後端 /cornerdetect API。
//
// 2026-10-02(kanban 1003418)單篇上傳恢復手動四角+分段動線,這條隨之重新生效:
// 調整邊界視窗打開時先送 /cornerdetect 預填四個角,偵測失敗或偵測不到就維持預設的
// 內縮框,學生照常手動拖角。它只決定「起點要不要預填」,送出的一律是學生在視窗裡
// 確認過的校正+分段結果。
//
// 旋轉動線(isRotateOnlyFlowEnabled 為 true)下這條不可達:initializePerspectivePoints
// 只在調整邊界視窗裡跑,而那個視窗被 !isRotateOnlyFlowEnabled() 擋著。
export function isAutoCornerDetectionEnabled(): boolean {
  return true;
}

// 上傳頁「只旋轉」動線(kanban 113663):把手動拉四角的校正視窗換成單欄旋轉視窗,
// 四角校正交給批改後端(hanlin-ai-composition-api process_task,環境變數
// SINGLE_CORNERDETECT 控制)。2026-08-28(kanban 1000655)起曾全環境開啟。
//
// 2026-10-02(kanban 1003418 前端、1003420 後端)起關閉,恢復舊動線:
// 上傳後先開「調整邊界」視窗拖四角校正 → 分割編輯器切成細條 → 送出細條。
//
// 前後端的配對方式:這次送出的 files 全部是前端已校正+分段的細條時,同一個請求
// 多帶 form 欄位 clientCorrected=1(UploadEssay 的 handleSubmitEssay → aiCorrecting),
// 後端看到就略過自己的四角校正;沒帶這個欄位的請求(整頁送出、旋轉動線)後端照舊校正。
//   · 不會二次校正:cornerdetect 沒有「已校正就跳過」的判斷,門檻方向還相反,
//     對前端校正過的細條再跑一次會往內再吃一圈紙邊——由 clientCorrected 告訴後端跳過
//   · 退回旋轉動線只要把下面改回 return true:旋轉動線不帶 clientCorrected,
//     後端照 SINGLE_CORNERDETECT 自己校正,後端設定不用動
//
// 不依 hostname 分歧:原本「QA 開、prod 關」造成過測試站前後端都沒校正、
// 而且從畫面上看不出來的破口(kanban 1000655)。
//
// 保留 return false 而不是刪掉整條:旋轉視窗的程式碼原封不動仍在,
// 要切換改這一行即可,不必 revert 加重新部署。
export function isRotateOnlyFlowEnabled(): boolean {
  return false;
}
